// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "c15bf2b0" : chunkId) + "." + {"415":"31a06afa676ac22e","478":"ca6625932e4c7dbb","592":"baed0b6bb6aa9b3e"}[chunkId] + ".js";
};